module.exports = __webpack_public_path__ + "static/img/thumb.46eaf14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sv/sv006/thumb.jpg
// module id = 5hYg
// module chunks = 0